const ajaxFilters = document.querySelector('.js-filters-hld');
if ( ajaxFilters) {
	import('../scripts/ajaxFilters').then(module => {
		module;
	});
}
